import React, { useEffect,useState } from "react";
import { Button, Empty, Pagination, Select, Dropdown, Space } from "antd";
import {
  DownOutlined,
  SmileOutlined,
  CopyOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import useStatsStore from "../../store/stats.store";
import useMembersStore from "../../store/members.store";
import useJDStore from "../../store/jd.store.js";
import RTableActionsModal from "../RTableActionsModal/index.jsx";
import useSettingstore from "../../store/settings.store";
import Table from "../Table";
import "./jdsConsolidated.scss";
import Filter from "../filter";

export default function JDsConsolidated(props) {

  const { jdsConsolidatedStats,getJdsConsolidatedStats,jdsConsolidatedStatsCount } = useStatsStore();
  const { getClients,clients} =  useMembersStore();
  const { duplicateJd, deleteJd } = useJDStore();
  const { getSettingByKey } = useSettingstore();
  const [isActionModalOpen, setIsActionModalOpen] = useState(false);
  const [action, setAction] = useState("");
  const [actionOnJD, setActionOnJD] = useState("");
  const [clientList, setSetClientList] = useState();

  const ClientAll = { value: 'All', label: 'All' }

  var clientInDB = clients?.map((client, idx) => {
    return {
      value:client?.ClientName,
      label:client?.ClientName,
    };
  })

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
   const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  useEffect(() => {
    getClients()
    clientInDB?.push(ClientAll)
    //console.log("clientList", clientList)
    //console.log("clientInDB", clientInDB)
    //console.log("ClientAll", ClientAll)
    clientInDB!= null ? setSetClientList([...clientInDB]):setSetClientList()
  }, []);

  const titleList = [
    "Sr. No.",
    "Posted On",
    "Posted By",
    "Last Updated",
    "Updated By",
    "Client",
    "TA",  
    "Job Title",
    "JD Status/Priority", 
    "Total Resumes", 
    "SPOC",
    "Assigned On",    
    "Assigned To",
    "BU/Project Name",
    "Hiring Manager",
    "JD Actions"
  ];

  const GetTeamAssignment =(jds)=>{
    var assignedTeam=''
    jds?.JDAssignment?.Assignments?.map((assign,idx)=>{
      if (assignedTeam === ''){
        assignedTeam = assign.AssignedToName;
      }else{
        assignedTeam = assignedTeam +','+assign.AssignedToName;
      }
      
     return })

     return assignedTeam
  }

  
  function formatUnixDate(ts) {
    const d = new Date(ts * 1000);
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    const yyyy = d.getFullYear();

    return `${dd}-${mm}-${yyyy}`;
  }

  const handleDuplicate = async () => {
    await duplicateJd(actionOnJD);
    setIsActionModalOpen(false);
    let filterObj = getSettingByKey("getJdsConsolidatedStats");
    getJdsConsolidatedStats(filterObj.value.filterDuration, filterObj.value);
  };

  const handleDelete = async () => {
    await deleteJd(actionOnJD);
    setIsActionModalOpen(false);
    let filterObj = getSettingByKey("getJdsConsolidatedStats");
    getJdsConsolidatedStats(filterObj.value.filterDuration, filterObj.value);
  };

  const items = [
    {
      key: "1",
      danger: false,
      label: (
        <>
          <CopyOutlined style={{ marginRight: "8px" }} />
          Duplicate JD
        </>
      ),
    },
    {
      key: "2",
      danger: true,
      label: (
        <>
          <DeleteOutlined style={{ marginRight: "8px" }} />
          Delete JD
        </>
      ),
    },
  ];

  const handleAction = (key, jdID) => {
    setIsActionModalOpen(true);
    if (key === "1") {
      setAction("DuplicateJD");
      setActionOnJD(jdID);
    } else if (key === "2") {
      setAction("DeleteJD");
      setActionOnJD(jdID);
    }
  };

  const handleCancel = () => {
    setIsActionModalOpen(false);
  };

  const jdsDetailData = jdsConsolidatedStats?.map((jds, idx) => {
    return {
      id: idx + 1,
      date_added: jds?.JDOther.PostingDate,  
      posted_by: jds?.JDOther.PostedBy,
      updated_on: jds?.timestamp?formatUnixDate(jds?.timestamp):"--",
      updated_by: jds?.updatedby==""?"--":jds?.updatedby,
      client_name: jds?.JDClient.ClientName,
      ta_name: jds?.JDClient.TaName,
      title: '['+jds?.QhCompanyJID+'] '+jds?.JDDetails.Title,
      priority: '['+jds?.JDProject.ReqStatus +"] "+jds?.JDOther.Priority,
      total_resumes:jds?.JDResumeList?.length>0?jds?.JDResumeList?.length:0,
      SPOC: jds?.JDAssignment?.Spoc,
      assignedOn: jds?.JDAssignment?.AssignedOn,      
      assignedTo: GetTeamAssignment(jds),
      buname: jds?.hiring_project_team_name,
      hiring_project_team_name: jds?.hiring_project_team_name,
      action: (
        <div onClick={(e) => e.stopPropagation()}>
          <Dropdown
            menu={{
              items,
              onClick: ({ key }) => handleAction(key, jds?.QhCompanyJID),
            }}
          >
            <a onClick={(e) => e.preventDefault()}>
              <Space>
                Select
                <DownOutlined />
              </Space>
            </a>
          </Dropdown>
        </div>
      ),
    };
  });

  return (
    <div className="teamTask-wrapper">
      <RTableActionsModal
        isModalOpen={isActionModalOpen}
        handleOk={action === "DuplicateJD" ? handleDuplicate : handleDelete}
        handleCancel={handleCancel}
        action={action}
        actionMessage={
          action === "DuplicateJD"
            ? "Duplicate JD " + actionOnJD + "?"
            : "Delete JD " + actionOnJD + "?"
        }
      />
      <div className="teamTask-title">
        ({jdsConsolidatedStatsCount || 0}) JDs
      </div>
      <div>
      <Filter
        filtername = {"getJdsConsolidatedStats"}
        initDuration={"24"}
        initPrio={"All"}
        initResume={"All"}
        initJDStatus={"Active"} 
        initClient={"All"}        
        pageNo = {currentPage}
        pageSize ={pageSize}  
        enableDuration
        enableResumes
        enablePriority
        enableJdStatus
        enableCustomers 
        enableTAs     
        handleFilter={getJdsConsolidatedStats}
        pageHandler = {setCurrentPage}  
      />
      <div></div>
      </div>
       
      {jdsConsolidatedStats?.length > 0 ? (
        <Table
          isClickable={true}
          isJDPage={true}
          titleList={titleList}
          data={jdsDetailData}
          columnWidth={[
            50, 100, 100, 100, 100, 100, 100, 230, 100, 90, 200, 100, 200, 200,
            200, 200,
          ]}
          currentProduct = {props?.product === "nujobs"?"nujobs":"qhrflow"}
        />
      ) : (
        <Empty style={{ margin: "60px" }} />
      )}

       <Pagination
              style={{ marginTop: "4px",  float: "inline-end" }}
              current={currentPage}
              pageSize={pageSize}
              total={jdsConsolidatedStatsCount}
              onChange={(page, pageSize) => {
                handlePageChange(page, pageSize);
                
              }}
              showSizeChanger
              pageSizeOptions={[10, 20, 50, 100, 150]}
        />      
    </div>
  );
}
